/**
 * Production-safe logger utility
 * Only logs in development, silently no-ops in production
 */

const isDevelopment = process.env.NODE_ENV !== 'production';

const logger = {
  debug: (message, ...args) => {
    if (isDevelopment) console.debug(`[DEBUG] ${message}`, ...args);
  },
  info: (message, ...args) => {
    if (isDevelopment) console.info(`[INFO] ${message}`, ...args);
  },
  warn: (message, ...args) => {
    if (isDevelopment) console.warn(`[WARN] ${message}`, ...args);
  },
  error: (message, ...args) => {
    if (isDevelopment) console.error(`[ERROR] ${message}`, ...args);
  }
};

export default logger;
